<template>
  <div>
    <my-notification :icon="'info'">
      <template #title>
        {{ $t('compCarbonFormsIntroduction.title-1') }}
      </template>
      <p>
        <b><em>Ekocentral GES</em></b
        >, {{ $t('compCarbonFormsIntroduction.info-1') }}
        <em>Labos 1point5</em>, {{ $t('compCarbonFormsIntroduction.info-2') }}.
        {{ $t('compCarbonFormsIntroduction.info-5') }}
      </p>
    </my-notification>
    <br />
    <b-notification :closable="false">
      <span style="margin-top: 8px">
        {{ $t('compCarbonFormsIntroduction.info-6') }}
        <b>{{ $t('compCarbonFormsIntroduction.info-7') }}</b>
        {{ $t('compCarbonFormsIntroduction.info-8') }}.
      </span>
    </b-notification>
    <!-- <b-notification :closable="false">
      <span style="margin-top: 8px">
        <b-tag rounded type="is-info">How to cite</b-tag>&nbsp;
        <em>An open-source tool to assess the carbon footprint of research.</em>
        Jérôme Mariette, Odile Blanchard, Olivier Berné, Olivier Aumont, Julian
        Carrey, Anne-Laure Ligozat, Emmanuel Lellouch, Philippe-Emmanuel Roche,
        Gaël Guennebaud, Joel Thanwerdas, Philippe Bardou, Gérald Salin, Elise
        Maigne, Sophie Servan and Tamara Ben-Ari. 2022 Environ. Res.:
        Infrastruct. Sustain. <strong>2</strong> 0350080
        <a
          target="_blank"
          class="link"
          href="https://doi.org/10.1088/2634-4505/ac84a4"
        >
          10.1088/2634-4505/ac84a4 </a
        >.
      </span>
    </b-notification> -->
    <!-- <b-notification :closable="false">
      <span style="margin-top: 8px">
        <b-tag rounded type="is-info">How to cite</b-tag>&nbsp;
        <em
          >Purchases dominate the carbon footprint of research laboratories.</em
        >
        Marianne De Paepe, Laurent Jeanneau, Jérôme Mariette, Olivier Aumont,
        Andre Estevez-Torres. 2024. PLOS Sustain Transform 3(7): e0000116.
        <a
          target="_blank"
          class="link"
          href="https://doi.org/10.1371/journal.pstr.0000116"
        >
          10.1371/journal.pstr.0000116 </a
        >.
      </span>
    </b-notification> -->
    <br />
    <h3 style="text-align: center; font-size: 1.1em">
      <b>
        {{ $t('compCarbonFormsIntroduction.title-2') }}
        <em>Ekocentral GES</em> ?</b
      >
    </h3>
    <div class="columns" style="margin: 25px 10px">
      <div class="column">
        <div class="columns col-border-shaddow">
          <div class="column col-rotate" style="background-color: #d14d65">
            <span class="title is-5" style="color: #fff">{{
              $t('compCarbonFormsIntroduction.info-9')
            }}</span>
          </div>
          <div
            class="column col-content col-content-1"
            @click="displayWhy = true"
          >
            <figure class="image is-40x40">
              <i class="fa fa-puzzle-piece" style="font-size: 40px"></i>
            </figure>
            <div v-html="$t('compCarbonFormsIntroduction.info-10')"></div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="columns col-border-shaddow">
          <div class="column col-rotate" style="background-color: #8a4869">
            <span class="title is-5" style="color: #fff">{{
              $t('compCarbonFormsIntroduction.info-11')
            }}</span>
          </div>
          <div
            class="column col-content col-content-2"
            @click="displayWhy = true"
          >
            <figure class="image is-40x40">
              <i class="fa fa-object-group" style="font-size: 40px"></i>
            </figure>
            <div v-html="$t('compCarbonFormsIntroduction.info-12')"></div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="columns col-border-shaddow">
          <div class="column col-rotate" style="background-color: #5f548d">
            <span class="title is-5" style="color: #fff">{{
              $t('compCarbonFormsIntroduction.info-13')
            }}</span>
          </div>
          <div
            class="column col-content col-content-3"
            @click="displayWhy = true"
          >
            <figure class="image is-40x40">
              <i class="fa fa-hubzilla" style="font-size: 40px"></i>
            </figure>
            <div v-html="$t('compCarbonFormsIntroduction.info-14')"></div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="columns col-border-shaddow">
          <div class="column col-rotate" style="background-color: #3b589f">
            <span class="title is-5" style="color: #fff">{{
              $t('compCarbonFormsIntroduction.info-15')
            }}</span>
          </div>
          <div
            class="column col-content col-content-4"
            @click="displayWhy = true"
          >
            <figure class="image is-40x40">
              <i class="fa fa-tags" style="font-size: 40px"></i>
            </figure>
            <div v-html="$t('compCarbonFormsIntroduction.info-16')"></div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="columns col-border-shaddow">
          <div class="column col-rotate" style="background-color: #0d7eb6">
            <span class="title is-5" style="color: #fff">{{
              $t('compCarbonFormsIntroduction.info-17')
            }}</span>
          </div>
          <div
            class="column col-content col-content-5"
            @click="displayWhy = true"
          >
            <figure class="image is-40x40">
              <i class="fa fa-podcast" style="font-size: 40px"></i>
            </figure>
            <div v-html="$t('compCarbonFormsIntroduction.info-18')"></div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />

    <div class="columns" v-if="!authStore.isAuthenticated">
      <div class="column">
        <div
          class="boxicon is-bordered has-text-centered"
          data-animation="fadeInLeft"
          style="margin-bottom: 0"
        >
          <div class="bicon">
            <a class="notlink"><b-icon icon="user-plus"></b-icon></a>
          </div>
          <h4>{{ $t('compCarbonFormsIntroduction.box-title-1') }}</h4>
          <br />
          <div class="content">
            <div>
              {{ $t('compCarbonFormsIntroduction.box-info-6') }}
              <em>Ekocentral GES</em>
              {{ $t('compCarbonFormsIntroduction.box-info-7') }} :
              <ul style="list-style: none; margin-left: 1em">
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-8') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-9') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-11') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-12') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-13') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-15') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-16') }}
                </li>
              </ul>
            </div>
            <button
              @click="authStore.openAuthModal('/administration/all-ghgi')"
              class="button is-primary is-fullwidth"
              style="margin-top: 65px"
            >
              <span class="icon is-small"><i class="fa fa-user"></i></span>
              <span>{{ $t('compCarbonFormsIntroduction.box-info-20') }}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="column">
        <div
          class="boxicon is-bordered has-text-centered"
          data-animation="fadeInLeft"
          style="margin-bottom: 0"
        >
          <div class="bicon">
            <a class="notlink"><b-icon icon="user-secret"></b-icon></a>
          </div>
          <h4>{{ $t('compCarbonFormsIntroduction.box-title-2') }}</h4>
          <br />
          <div class="content">
            <div>
              {{ $t('compCarbonFormsIntroduction.box-info-21') }}
              <em>Ekocentral GES</em>
              {{ $t('compCarbonFormsIntroduction.box-info-7') }} :
              <ul style="list-style: none; margin-left: 1em">
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-8') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-9') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-11') }}
                </li>
                <li>
                  <span class="icon is-small"><i class="fa fa-check"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-12') }}
                </li>
                <li style="opacity: 0.4; color: #ff3860">
                  <span class="icon is-small"><i class="fa fa-close"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-13') }}
                </li>
                <li style="opacity: 0.4; color: #ff3860">
                  <span class="icon is-small"><i class="fa fa-close"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-15') }}
                </li>
                <li style="opacity: 0.4; color: #ff3860">
                  <span class="icon is-small"><i class="fa fa-close"></i></span>
                  {{ $t('compCarbonFormsIntroduction.box-info-16') }}
                </li>
              </ul>
            </div>
            <b-checkbox
              class="small"
              @input="charteAnonymeChanged"
              v-model="charteValidAnonyme"
            >
              {{ $t('compCarbonFormsIntroduction.box-info-17') }}
              <router-link
                class="link"
                target="_blank"
                to="/labos1point5-charter"
              >
                {{ $t('compCarbonFormsIntroduction.box-info-18') }}
              </router-link>
              {{ $t('compCarbonFormsIntroduction.box-info-19') }}
              <em>Labos 1point5</em>.
            </b-checkbox>
            <br />
            <br />
            <button
              class="button is-primary is-fullwidth"
              :disabled="!charteValidAnonyme"
              @click="start"
              type="submit"
            >
              <span class="icon is-small"
                ><i class="fa fa-arrow-circle-right"></i
              ></span>
              <span>{{ $t('compCarbonFormsIntroduction.box-info-22') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="columns" v-if="authStore.isAuthenticated && !flags.isValid">
      <div class="column is-half is-offset-one-quarter">
        <div
          class="boxicon is-bordered has-text-centered"
          data-animation="fadeInLeft"
          style="margin-bottom: 0"
        >
          <div class="content">
            <p>
              {{ $t('compCarbonFormsIntroduction.box-info-26') }}
            </p>
            <br />
            <form>
              <b-checkbox class="small" v-model="charteValid">
                {{ $t('compCarbonFormsIntroduction.box-info-17') }}
                <router-link
                  class="link"
                  target="_blank"
                  to="/labos1point5-charter"
                  >{{ $t('compCarbonFormsIntroduction.box-info-18') }}
                </router-link>
                {{ $t('compCarbonFormsIntroduction.box-info-19') }}
                <em>Labos 1point5</em>.
              </b-checkbox>
              <b-checkbox class="mt-10 small" v-model="confidentialite">
                {{ $t('compCarbonFormsIntroduction.box-info-17') }}
                <router-link
                  class="link"
                  to="/politique-de-confidentialite"
                  target="_blank"
                >
                  {{
                    $t('compCarbonFormsIntroduction.box-info-23')
                  }}</router-link
                >
                {{ $t('compCarbonFormsIntroduction.box-info-19') }}
                <em>Labos 1point5</em>.
              </b-checkbox>
              <b-checkbox class="mt-10 small" v-model="habilitation">
                {{ $t('compCarbonFormsIntroduction.box-info-24') }}
                <em>Labos 1point5</em>.
              </b-checkbox>
              <br />
              <br />
              <button
                class="button is-primary is-fullwidth"
                :disabled="!charteValid || !habilitation || !confidentialite"
                @click="start"
                type="submit"
              >
                <span class="icon is-small"
                  ><i class="fa fa-arrow-circle-right"></i
                ></span>
                <span>{{ $t('compCarbonFormsIntroduction.box-info-22') }}</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

    <b-modal :active.sync="displayWhy" has-modal-card :width="1000">
      <div class="modal-card" style="width: 1000px">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('compCarbonFormsIntroduction.box-info-25') }}
          </p>
        </header>
        <section class="modal-card-body">
          <why-ges-1point5 />
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { useAdminStore } from '@/stores/admin.js'
import { useAuthenticationStore } from '@/stores/authentication.js'

export default {
  name: 'Introduction',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue'),
    'why-ges-1point5': () => import('@/components/carbon/docs/Why.vue')
  },
  props: {
    flags: {
      type: Object
    }
  },
  data () {
    return {
      displayWhy: false,
      charteValid: false,
      habilitation: false,
      confidentialite: false,
      charteValidAnonyme: false
    }
  },
  setup () {
    const adminStore = useAdminStore()
    const authStore = useAuthenticationStore()
    return { adminStore, authStore }
  },
  methods: {
    start: function () {
      this.$emit('valid')
    },
    charteAnonymeChanged () {
      if (!this.charteValidAnonyme) {
        this.$emit('invalid')
      }
    }
  },
  mounted () {
    this.charteValidAnonyme = this.flags.isValid
  }
}
</script>

<style lang="css" scoped>
.boxicon .content {
  text-align: justify !important;
}
.col-border-shaddow {
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  background-color: #fff;
  text-align: center;
}
.col-rotate {
  transform: rotate(-90deg);
  width: 185px;
  height: 48px;
  margin-top: 48px;
  margin-left: -56px;
  margin-right: -56px;
  text-align: center;
  border-radius: 15%;
}
.col-content {
  padding-top: 4px;
  padding-bottom: 4px;
  cursor: pointer;
  margin: auto;
}
.col-content-1 {
  color: #d14d65;
}
.col-content-1:hover {
  background-color: #d14d65;
  opacity: 0.8;
  color: #fff;
}
.col-content-2 {
  color: #8a4869;
}
.col-content-2:hover {
  background-color: #8a4869;
  opacity: 0.8;
  color: #fff;
}
.col-content-3 {
  color: #5f548d;
}
.col-content-3:hover {
  background-color: #5f548d;
  opacity: 0.8;
  color: #fff;
}
.col-content-4 {
  color: #3b589f;
}
.col-content-4:hover {
  background-color: #3b589f;
  opacity: 0.8;
  color: #fff;
}
.col-content-5 {
  color: #0d7eb6;
}
.col-content-5:hover {
  background-color: #0d7eb6;
  opacity: 0.8;
  color: #fff;
}
</style>
